<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="alfred"><br/><br/>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:3.375in;height:2.37639in"/></p>
<h1>Alfred</h1>
<p style="text-indent:0em">She named him Alfred.</p>
<p style="text-indent:0em">The tree where we would park</p>
<p style="text-indent:0em">and talk about dreams</p>
<p style="text-indent:0em">or climb in the back seat</p>
<p style="text-indent:0em">and create our passion scenes.</p><br/>
<p style="text-indent:0em">Back in the days</p>
<p style="text-indent:0em">when people parked</p>
<p style="text-indent:0em">instead of tweeted,</p>
<p style="text-indent:0em">and loved instead of liked.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?5797af9c